export const thinkHard = [
    {
        type: 'th',
        isOpen: true,
        time: 40,
        fullTime: '12:20~13:00',
        afterBreak: true,
        profile: {
            name: '옥지혜',
            src: ['/img/thinkHard/0.jpeg'],
            desc: '제품 팀과 디지털 환경에서 사용자에게 가치로운 경험을 제공하고 이를 수익화 합니다.' +
                '다양한 구성원이 존중 받으며 일할 수 있는 문화 만들기에 관심이 많습니다.\n'
        },
        event: {
            title: '사람을 좋아하는 마음만으로 일을 할 수 있을까?',
            desc: 'PM이자 리더인 여성으로써 업무조율 및 팀을 운영하는 이야기 + 그간의 경험\n\n' +
                '제품 팀에게 비즈니스 목표가 가지는 의미\n' +
                '제품 팀이 비즈니스 목표 중심으로 작업하기 위한 방법\n' +
                '제품 팀의 협업이 가지는 의미\n' +
                '우리가 팀으로 성장할 수 있는 방법\n',
            materialLink: false
        }
    },
    {
        type: 'th',
        isOpen: true,
        time: 40,
        fullTime: '13:20~14:00',
        afterBreak: true,
        profile: {
            name: '강미경',
            src: ['/img/thinkHard/1.jpg'],
            desc: '전공은 삽질, 취미는 일, 특기는 커뮤니티. 9년차 서비스 기획자 강미경입니다.\n' +
                '요즘은 배달의 민족에서 사장님 가게를 위한 광고를 만드는데 빠져삽니다.\n'
        },
        event: {
            title: '기획자는 어떻게 SQL을 공부할까?\n- 배움의 자세와 도전정신',
            desc: 'App UI/UX 기획이라는 본연의 업무에서 벗어나\n다른 기술(SQL을 이용한 데이터 분석)에 관심을 갖게된 배경과 스터디의 과정,\n그리고 스킬 향상으로 얻은 이직의 기회와 새로운 도전을 이야기하고자 합니다.',
            materialLink: 'https://speakerdeck.com/minieetea/gihoegjaneun-eoddeohge-sqleul-gongbuhalgga-wtm2019'
        }
    },
    {
        type: 'th',
        isOpen: true,
        time: 20,
        fullTime: '14:20~14:40',
        afterBreak: false,
        profile: {
            name: '장유미',
            src: ['/img/thinkHard/2.jpg'],
            desc: '10년 차 힙합 댄서에서 UI,UX 디자이너가 된, 또 다른 열병을 앓고 있는 장유미라고 합니다!'
        },
        event: {
            title: '카르페디엠 - 오늘이 마지막인 것 처럼\n',
            desc: '댄서에서 디자이너로 - 취업을 위한 포트폴리오 설계, 그리고 지원서, 현업에서의 업무\n' +
                '10년 댄서에서 지금까지 살아온 원동력,\n' +
                '그리고 춤을 포기하고 희귀난치병을 가지고 삶을 헤맬 때, 다른 꿈을 찾기 위해 노력했던 과정\n' +
                '그리고 현재에 와서 제가 직업을 찾고 살아가는 이야기들 그리고 또 그 자체의 모순들,\n' +
                '새 삶을 찾았지만 그 고민들이 멈춰지는 것은 아니었습니다!\n' +
                '살아가는 디자이너의 앞으로의 앞날들을 쉐어하고 싶습니다!\n' +
                '누군가에게 희망이 되고, 도움이 된다면 더 이상 기쁜 일이 있을까요!!\n',
            materialLink: false
        }
    },
    {
        type: 'th',
        isOpen: true,
        time: 20,
        fullTime: '14:40~15:00',
        afterBreak: true,
        profile: {
            name: '김현미',
            src: ['/img/goWild/1.jpg'],
            desc: '현재 네이버 쇼핑플랫폼팀에서 프론트엔드 개발자로 일하고있습니다.\n' +
                '지속적인 성장에 관심 많습니다.\n'
        },
        event: {
            title: '웹마스터에서 프런트엔드 개발자로의 여정',
            desc: `저는 웹 마스터로 개발을 시작하여 백엔드 개발자, 앱 개발자를 거쳐 프런트 엔드 개발자로 커리어 전환을 한 11년 차 개발자입니다.
            커리어 전환을 하게 된 이유, 방법, 난관, 그리고 깨닫게 된 사실을 이야기하려고 합니다`,
            materialLink: 'https://www.slideshare.net/hyeonmikim77/wtm2019-140766273'
        }
    },
    {
        type: 'th',
        isOpen: true,
        time: 40,
        fullTime: '15:20~16:00',
        afterBreak: true,
        profile: {
            name: '에이미 장',
            src: ['/img/thinkHard/4.jpg'],
            desc: `현재 구글 코리아에서 글로벌한 구글 제품을 개발팀과 함께 만들어나가는 프로덕트 매니저입니다. 
            그 전에는 Android Things에서 10여명의 조직의 개발팀장이었으며, 
            Google Weave, Google Search UX 및 Google Play Books팀을 거치며 5년 이상 개발자로 근무하였습니다.`
        },
        event: {
            title: '원하는 것을 얻는 방법 - 구글 개발자/개발팀장/프로덕트 매니저를 거쳐온 커리어 이야기',
            desc: `커리어 골에 한걸음 더 다가갈 수 있는 구체적인 방법들을 공유해드립니다:
            1. 조직내에서 나를 성장시키고 커리어를 계획하는 방법
            2. 원하는 것을 얻을 수 있는 커뮤니케이션 방법
            3. 매니저와의 효과적인 관계설정 방법
            주로 제가 개발팀에서 일하면서 겪은 일들이지만, 알려드리는 방법들은 다른 직군에도 쓰일 수 있습니다. 
            추가로 제가 경험하며 느낀 개발자, 개발팀장, 프로덕트 매니저 각 직군의 차이점도 소개해드립니다.`,
            materialLink: false
        }
    },
    {
        type: 'th',
        isOpen: true,
        time: 40,
        fullTime: '16:20~17:00',
        afterBreak: true,
        profile: {
            name: '박설아 / 이다솔',
            src: ['/img/thinkHard/5-1.jpeg', '/img/thinkHard/5-2.jpeg'],
            desc: `박설아 : 역사를 공부하며 세상을 비판하다가, 우연히 기획자가 되어 각종 전시와 이벤트를 만들고 있습니다. 
            유연해지기, 큰 소리로 말하기, 어디로든 여행가기 등에 관심이 있습니다.
            / 이다솔 : 물리와 철학이라는 남초 학문을 공부하다 얼떨결에 과학 기자가 되어 잡지를 만들고 있습니다. 
            고양이한테 안 물리기, 힘 쎄지기, 안 다치고 복수하기 등에 관심이 있습니다.`
        },
        event: {
            title: '과학에서의 성차별에 과학적으로 맞서기 - 재치, 생각할거리, 새로운 시각',
            desc: `"남자는 수학을 잘하고 여자는 언어를 잘해."
            "남성은 여성보다 성욕이 많도록 진화했어."
            
            이런 말들이 우리 사회의 성차별을 강화하고 있다는 것을 알면서도 과학적인 단어가 섞여 있다는 이유로 말문이 턱 막힌 경험이 있습니다. 
            이에 대항할 언어를 찾지 못해 방황하다 책읽기 모임을 만들었습니다. 여기에 생각보다 많은 사람들이 관심을 가져주셔서 놀랐습니다.
            우리가 읽었던 책 6권과 그 책을 읽은 과정을 공유하려고 합니다. 과학의 탈을 쓴 성차별과 맞짱뜰 언어를 찾기 위해 고민하는 시간이 되었으면 합니다.`,
            materialLink: 'https://docs.google.com/presentation/d/1Gfsw4h-KmC78WidN3SRNrpcLDjDsd1LTcrKBKVlOrGw/edit?usp=sharing'
        }
    },
    {
        type: 'th',
        isOpen: true,
        time: 40,
        fullTime: '17:20~18:00',
        afterBreak: true,
        profile: {
            name: '노윤미',
            src: ['/img/thinkHard/6.jpg'],
            desc: `구글에 소프트웨어 엔지니어로 갓 입사했습니다. 주전공은 언론정보학인데, 복수전공으로 컴퓨터공학을 공부해서 엔지니어로 일하고 있어요. 
            페미니스트 프로그래머로서, 어제보다 오늘 더, 오늘보다 내일 더 나은 사람이 되기 위해서 노력하고 있습니다.`
        },
        event: {
            title: '여자답게 도전하기 - 구글 신입 엔지니어가 되기까지',
            desc: `우리의 삶은 수많은 도전으로 이루어져 있습니다. 하지만 자주, ‘여자답다' 혹은 ‘여자답지 못하다'는 말이 발목을 잡고는 하죠. 
            여성들은 아주 오랜 시간동안 이런 ‘여자다움'과 맞서 싸워야만 했습니다. 타인의 편견 뿐만 아니라, 나 자신의 편견과도요. 
            여자답게 도전한다는 것은 무엇일까요?
            저는 꽤 오랜 시간동안 작고 큰 도전들을 통해 ‘내가 하고 싶은 것’을 탐색했습니다.
            하지만 그 과정에서 ‘여자다움'이라는 말이 저에게 미친 영향이 작지 않았습니다. 
            ‘여자다움’을 극복하기 위해 제가 겪었던 어려움들, 그리고 도움이 되었던 것들을 공유하고 싶습니다.`,
            materialLink: 'https://drive.google.com/file/d/1SvW7wM23XtWEg4RJ4Ynbw1NnkC2TIsFa/view?usp=sharing'
        }

    }
];


export const goWild = [
    {
        type: 'gw',
        isOpen: true,
        time: 40,
        fullTime: '12:20~13:00',
        afterBreak: true,
        profile: {
            name: '오혜진',
            src: ['/img/goWild/0.jpg'],
            desc: '코인원에서 마크업 개발을 하고 있습니다. \n디자인, UX, 마크업, 프론트엔드, 데이터 분석 등 \n프로덕트를 이루는 다양한 분야에 관심이 많습니다.'
        },
        event: {
            title: '스타트업에서 마크업 개발자로 살아남기',
            desc: '웹 퍼블리셔라는 직군이 웹 에이전시 쪽에서는 흔하게 접할 수 있지만 보통의 중소기업이나 스타트업에서는 많이 알려지지 않은 직군입니다.\n ' +
                '디자이너가 약간의 코딩을 하거나, 프론트엔드 개발자가 마크업 영역을 커버하기도 하죠. \n' +
                '디자이너도 아니고 개발자도 아니라는 불명예(?)를 가질 때도 있었지만 스타트업에서 지난 5년간 고군분투하며 성장해 온 저의 이야기를 들려주고 싶습니다. \n' +
                '또한 다른 개발자 분들에게도 마크업 개발자가 어떤 역할을 하고 프로덕트에 기여할 수 있는지에 대해 알 수 있도록 알리는 자리를 가질 수 있었으면 좋겠습니다.',
            materialLink: 'https://www.slideshare.net/ohyejin91/190413-140764803'
        }
    },
    {
        type: 'gw',
        isOpen: true,
        time: 20,
        fullTime: '13:20~13:40',
        afterBreak: false,
        profile: {
            name: '강영화',
            src: ['/img/thinkHard/5.png'],
            desc: `띵스플로우에서 디자인을 담당한다. 시각디자인과를 졸업해 PR 회사에서 사회생활을 시작해 스타트업에서 풀스택 디자이너로 일해왔다. 스포카 한 산스나 한글 웹폰트 글꼴보기집 등 한글 웹 타이포그래피에 관심이 많다. 요새는 회사 키우기와 필요한 일을 어떻게 하면 효과적으로 잘 할 수 있을지 가장 오래 고민한다. 보이는 디자인도 좋지만 문제 해결 자체가 더 재밌다. 본인이 생각해도 고에너지 인간. 
            
            **발표 및 이벤트 모더레이션 경력**
            - 비핸스 포트폴리오 리뷰 2017 오거나이저 
            - 비핸스 포트폴리오 리뷰 2018 연사
            - 스포카 한 산스 관련 강연 2회 
            - Spoqa Design Month 모더레이터
            - 프로그래머 행사 부스 오거나이저
            - 2018 여성 기획자 컨퍼런스 라이트닝 토크 참가
            - 오프라인 이벤트 플랫폼 밋고 대표자`
        },
        event: {
            title: '가제- 회사에서 똑똑하게 살아남기',
            desc: `회사에서 어떻게 하면 한 사람의 직장인으로, 하지만 더 똑똑하게 살아남을 수 있을지 구체적인 사례를 언급하며 여성 청자에게 임파워링하는 발표를 할 예정입니다.  
            - 회사 생활을 하면서 어려웠던 점 
            - 일 잘하는 노하우 
            - 내 편 만들기 
            - 연봉을 최대한 올리자 
            - 성평등한 업계를 위해 개인이 할 수 있는 일 
            - 변화는 있다`,
            materialLink: false,
        }
    },
    {
        type: 'gw',
        isOpen: true,
        time: 20,
        fullTime: '13:40~14:00',
        afterBreak: true,
        profile: {
            name: '마르타',
            src: ['/img/goWild/2.jpeg'],
            desc: ' (전) 삼성전자 네트워크 사업부 영업/마케팅, K-Startup Grand Challange 프로그램 매니저, 스타트업 활동 및 지원, 장고걸스 서울\n' +
                '(현): 스타트업 위크앤드 서울 운영팀, Seoul Startups 운영진'
        },
        event: {
            title: '글로벌 vs 현지 - 여성 개발자/스타트업 커뮤니티 분석 ',
            desc: '1. Intro : 커뮤니티? 이거 뭔지???\n' +
                '2. 글로벌 케이스 스터디 : Django Girls, Girls in Tech, Women in Tech\n' +
                '3. 현지 커뮤니티 : 헤이조이스, 스여일삶, 등\n' +
                '4. Local+Global : 스타트업 위크앤드\n' +
                '5. Where do we go from here? 사회적으로 impact 있는 커뮤니티 단체의 트렌드\n',
            materialLink: 'https://docs.google.com/presentation/d/13vBLXHoBVEMeAVSI3B_FnVSWoN9ciSk1FBOwzLU0kDU/edit?usp=sharing',

        }
    },
    {
        type: 'gw',
        isOpen: true,
        time: 20,
        fullTime: '14:20~14:40',
        afterBreak: false,
        profile: {
            name: '이은지',
            src: ['/img/goWild/3.jpg'],
            desc: '여성 데이터분석가 양성 프로그램인 데잇걸즈3에서 기획/홍보/대외협력을 담당하고 있습니다. \n' +
                '데이터 분석 교육 분야와 야구 통계 데이터 활용에 관심이 많고, \n다양한 온/오프라인 채널을 통하어 데이터 교육 프로그램을 수강했습니다.'
        },
        event: {
            title: '데이터 분석 교육 프로그램 기획자의 커리어 이야기',
            desc: '커리어 전환이야기 - 대기업 회계에서 데이터과학 분야로\n' +
                'SI/OS 대기업 회계팀 대리로부터 데이터 분석 교육 프로그램 기획자로 커리어를 변경하게 된 과정에 대한 소개입니다.',
            materialLink: 'https://bit.ly/WTM2019_EunJiLee',

        }
    },
    {
        type: 'gw',
        isOpen: true,
        time: 20,
        fullTime: '14:40~15:00',
        afterBreak: true,
        profile: {
            name: '이지영',
            src: ['/img/goWild/4.jpg'],
            desc: `thingsflow 에서 헬로우봇 서비스의 안드로이드, IOS 앱을 개발하고 있습니다.
            제품을 만들고 제품을 통해 가치를 제공하며, 각기 다른 직무의 팀원들과 협업하여 사용자 관점에서 보다 나은 프로덕트를 만들기 위해 고민하고 매출을 내 성장해가는, 스타트업에서 경험할 수 있는 모든 과정을 사랑하는 모바일 앱 개발자입니다.`
        },
        event: {
            title: '성장으로 가는 길 - 어쩌다 유랑기',
            desc: `어쩌다 사소한 계기로 시작했던 많은 것들이, 어느 순간부터 점이 아닌 선으로 연결되는 경험을 하게 되었습니다. 점을 이룬 저의 경험들을 간략히 소개하고, 그걸 선으로 연결될 수 있게 한 저의 고민, 고민을 통해 정립된 저의 성장공식들에 대해 이야기합니다.`,
            materialLink: 'https://www.slideshare.net/mobile/ssuseree043b/2019-women-techmakers-seoul-jiyoung-lee-140755422',

        }
    },
    {
        type: 'gw',
        isOpen: true,
        time: 20,
        fullTime: '15:20~15:40',
        afterBreak: false,
        profile: {
            name: '배인진',
            src: ['/img/goWild/5.jpg'],
            desc: '안드로이드 개발자입니다. 터치게임 앱을 개발하면서 인터랙션과 애니메이션 구현에 더욱 흥미를 갖게 되었고, 상용 앱에 적용했던 내용을 발표하려고 합니다.'
        },
        event: {
            title: 'Android Animation without library',
            desc: `이 세션을 통해 Android Animation API를 이해하고, 다양한 상황의 Animation 구현을 능숙하게 하는 것을 목표로 합니다.
            1. Android Animation APIs 
            2. 연습 - 어떤 API를 사용해 구현할까?
            3. 실전 - Lottie 없이 만드는 Custom Animation`,
            materialLink: false,

        }
    },
    {
        type: 'gw',
        isOpen: true,
        time: 20,
        fullTime: '15:40~16:00',
        afterBreak: true,
        profile: {
            name: '신정아',
            src: ['/img/goWild/6.jpg'],
            desc: '모바일  환경에서의  머신러닝  기술에  가치를  느끼는  안드로이드  개발자입니다. \n' +
                '모두의연구소  MoT(Machine  Learning  of  Things)  랩에서  Tensorflow  Lite 과 \n' +
                'ML Kit, Android NN API 에  대해  연구하고  있습니다. Research Engineer 들과의 \n' +
                '더  나은  협업을  위해  딥러닝을  공부하며,  지표  측정과  테스트를  생활화  합니다.'
        },
        event: {
            title: '함께  걷는  모바일  머신러닝  앱  성능  최적화, Step by Step  ',
            desc: 'Tensorflow Lite 과 ML Kit을 활용한 모바일 머신러닝 Vision 어플리케이션을 개발할 때, 앱 성능을 개선할 수 있는 방안들에 대해 Step by Step으로 점검합니다. \n' +
                'Vision 딥러닝 모델을 응용하여 앱을 개발할 때, 성능에 병목이 오는 문제 상황들을 실제의 DEMO로써 살펴본 후, \n' +
                '- 문제 상황을 해결하기 위한 성능 개선 방안과 도입 방법에 대해 설명합니다.\n' +
                '- 성능 개선 효과를 다양한 모바일과 머신러닝의 지표들과 함께 살펴봅니다.',
            materialLink: 'https://www.slideshare.net/ShinJeongah/women-techmakers-seoul-2019-step-by-step',

        }
    },
    {
        type: 'gw',
        isOpen: true,
        time: 40,
        fullTime: '16:20~17:00',
        afterBreak: true,
        profile: {
            name: '홍지혜',
            src: ['/img/goWild/7.jpeg'],
            desc: `LG전자에서 웹 표준 활동을 하며 늘 새로운 도전을 즐기는 엔지니어입니다. W3C 표준 단체에서  CSS 표준 편집자로  활동하고 있으며 CSS 뿐만 아닌 다양한 웹 최신 기술에 관심이 많습니다.`
        },
        event: {
            title: '웹 표준 도전하기',
            desc: `국내 여성 엔지니어로서는 유일하게 W3C 표준화 단체 내에서 웹 표준 편집자로 활동 중입니다.
            * 웹 표준이란 무엇인지, 왜 중요한지
            * 웹 표준 활동을 해온 과정
            * 웹 표준에 참여할 수 있는 방법
            에 대하여 나누고자 합니다.`,
            materialLink: 'https://docs.google.com/presentation/d/1B1Riw1kV4lBdoFv8XFgVRQ47t0zvmX2eLJaB18TUG20/edit?usp=sharing',

        }
    },
    {
        type: 'gw',
        isOpen: true,
        time: 40,
        fullTime: '17:20~18:00',
        afterBreak: true,
        profile: {
            name: '이지수',
            src: ['/img/goWild/8.jpg'],
            desc: '다이어트/피트니스 브랜드 다노 공동대표\n' +
                '-저서: 《습관 성형》, 《마인드 스트레칭》\n' +
                '-2017년 포브스 아시아가 선정한 30세 이하 영향력 있는 건강/과학분야 30인\n' +
                '\n' +
                '다이어트 식단 전문 쇼핑몰 다노샵, 온라인 습관 성형 다이어트 프로그램인 마이다노\n' +
                '그리고 국내 최대 여성 다이어트 커뮤니티를 운영하며 \n' +
                '100만 팔로워와 소통하는 다이어트 멘토\n' +
                '\n' +
                '다노의 비전은 ‘BE THE BEST VERSION OF YOU’입니다. \n' +
                '모든 사람들에게 잠재된 최고의 모습을 이끌어낸다는 사명과\n' +
                '습관 성형이라는 솔루션 아래 대한민국의 다이어트 패러다임을 바꾸는 것이 이지수 대표와 다노의 목표입니다.\n'
        },
        event: {
            title: '인생 속의 \'일\'에 대한 이야기. 행복하게 일을 하기 위한 직무자존감',
            desc: '건강한 자아를 위해서 단단한 자존감이 필요하듯이,\n 건강하고 행복한 업을 영위하기 위해서도 \'직무자존감\'이 반드시 필요하다.\n' +
                '일을 할 때에 내가 무엇을 좋아하고 무엇을 싫어하는지, 언제 행복하고 언제 불행한지, \n' +
                '어떤 가치를 지향하고 무엇을 대변하는 사람이고 싶은지, \n' +
                '어떤 신념을 품고 일을 대하는지가 직무자존감을 만든다. \n내가 직무자존감을 만들어가게 된 과정에 대해 공유하고자 한다.',
            materialLink: false,

        }
    }
];


export default {
    thinkHard,
    goWild
}
